"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.IconClickable = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconLabel = require("../IconLabel/IconLabel");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

const IconClickable = props => {
  const {
    id,
    link,
    handleClick,
    leftIcon,
    rightIcon,
    text,
    clkContainerCssModifier,
    lblContainerCssModifier,
    length,
    maxLength,
    disabled,
    type,
    routerLink: Link,
    analytics
  } = props;
  let contents;
  if (maxLength && length >= maxLength) return null;
  if (link !== null) {
    if (type !== 'hyperlink') {
      const {
        to,
        replace
      } = link;
      contents = /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
        to: to,
        replace: replace,
        onClick: () => handleClick(),
        className: `ccl-e-icon-clickable__link ccl-e-icon-clickable__link--${clkContainerCssModifier}`,
        "data-nw-action": id,
        "data-analytics": analytics,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
          leftIcon: leftIcon,
          rightIcon: rightIcon,
          text: text,
          lblContainerCssModifier: lblContainerCssModifier
        })
      });
    } else {
      const {
        to
      } = link;
      contents = /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: to,
        className: `ccl-e-icon-clickable__link ccl-e-icon-clickable__link--${clkContainerCssModifier}`,
        "data-nw-action": id,
        "data-analytics": analytics,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
          leftIcon: leftIcon,
          rightIcon: rightIcon,
          text: text,
          lblContainerCssModifier: lblContainerCssModifier
        })
      });
    }
  } else {
    contents = /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: () => handleClick(),
      className: `ccl-e-icon-clickable__button ccl-e-icon-clickable__button--${clkContainerCssModifier}`,
      "data-nw-action": id,
      disabled: disabled,
      "data-analytics": analytics,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLabel.IconLabel, {
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        text: text,
        lblContainerCssModifier: lblContainerCssModifier
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "ccl-e-icon-clickable",
    children: contents
  });
};
exports.IconClickable = IconClickable;
IconClickable.defaultProps = {
  id: '',
  link: null,
  handleClick: () => {},
  leftIcon: null,
  rightIcon: null,
  text: '',
  clkContainerCssModifier: 'tool-bar',
  lblContainerCssModifier: 'mobile-hidden',
  length: 0,
  maxLength: undefined,
  disabled: false,
  type: '',
  routerLink: undefined
};